import { HTMLAttributes } from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '../../lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded-md font-medium ring-1 ring-inset',
  {
    variants: {
      variant: {
        default: 'bg-primary-50 text-primary-700 ring-primary-700/10',
        secondary: 'bg-gray-50 text-gray-700 ring-gray-700/10',
        success: 'bg-green-50 text-green-700 ring-green-700/10',
        warning: 'bg-yellow-50 text-yellow-700 ring-yellow-700/10',
        danger: 'bg-red-50 text-red-700 ring-red-700/10',
        error: 'bg-red-50 text-red-700 ring-red-700/10',
        info: 'bg-blue-50 text-blue-700 ring-blue-700/10',
      },
      size: {
        xs: 'px-1 py-0.5 text-xs',
        sm: 'px-1.5 py-0.5 text-xs',
        md: 'px-2 py-1 text-xs',
        lg: 'px-2.5 py-1.5 text-sm',
      },
      colorScheme: {
        gray: 'bg-gray-50 text-gray-700 ring-gray-700/10',
        red: 'bg-red-50 text-red-700 ring-red-700/10',
        yellow: 'bg-yellow-50 text-yellow-700 ring-yellow-700/10',
        green: 'bg-green-50 text-green-700 ring-green-700/10',
        blue: 'bg-blue-50 text-blue-700 ring-blue-700/10',
        indigo: 'bg-indigo-50 text-indigo-700 ring-indigo-700/10',
        purple: 'bg-purple-50 text-purple-700 ring-purple-700/10',
        pink: 'bg-pink-50 text-pink-700 ring-pink-700/10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  }
)

export interface BadgeProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, colorScheme, color, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant, size, colorScheme }), className)} {...props} />
  )
}

export { Badge, badgeVariants }